import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Flex, UiText } from '@shared/ui';

import cls from './UnreadDivider.module.css';

interface IUnreadDividerProps {
    className?: string;
}
export const UnreadDivider = ({ className }: IUnreadDividerProps) => {
    const { t } = useTranslation();
    return (
        <Flex className={cn(cls.UnreadDividerContainer, className)} fullWidth justify="center">
            <UiText className={cls.UnreadDividerText}>
                {t('Comments.UnreadComments.Divider')}
            </UiText>
        </Flex>
    );
};
